import React, { useState, useEffect } from 'react'
import { Button, Col, Icon, IconButton, Input, InputGroup, Panel, Row, SelectPicker } from 'rsuite'
import { useForm, Controller, useFieldArray } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { v4 as uuidv4 } from 'uuid'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { isEmpty } from 'lodash-es'
import notification from '../../utils/notification'
import pathname from '../../constants/pathname'
import { saveAssessmentConfigMasterClosureQuestion } from '../../redux/actions/assessment'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { doneLoading, startLoading } from '../../utils/loading'

export default function AddMasterQuestionWidget(props) {
  const history = useHistory()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isLoading, setIsLoading] = useState(false)
  const [categories, setCategories] = useState([])

  const clone = (obj) => JSON.parse(JSON.stringify(obj))

  useEffect(() => {
    if(formSchema){
      setFormSchema(formSchema)
      setCategories(formSchema?.masterClosureQuestion?.length > 0
      ? formSchema?.masterClosureQuestion
      : [{ id: `${uuidv4()}`, masterQuestionName: null }])
    }
  }, [formSchema])

  const handleSave = async (repuest) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await saveAssessmentConfigMasterClosureQuestion(repuest)
      if (response) {
        setFormSchema(response)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errors?.message,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleChange = (value, key, id) => {
    const updated = categories.map((item) => (item.id === id ? { ...item, [key]: value } : item))
    setCategories(updated)
  }

  const handleAddSameLevel = (id) => {
    const updated = clone(categories)

    const newid = `new-${uuidv4()}`
    const index = updated.findIndex((item) => item.id === id)

    if (index !== -1) {
      updated.splice(index + 1, 0, { id: newid, masterQuestionName: null })
    } else {
      updated.push({ id: newid, masterQuestionName: null })
    }

    setCategories(updated)
  }

  const handleRemove = (path) => {
    const updated = clone(categories)
    const lastIndex = path[path.length - 1]
    let current = updated

    // หาตำแหน่งของ parent array
    path.slice(0, -1).forEach((i) => {
      current = current[i].children
    })

    if (path.length === 1 && current.length <= 1) {
      notification.open('error', {
        title: 'ไม่สามารถลบได้ ต้องเหลือหมวดหมู่หลักไว้อย่างน้อย 1 รายการ',
        duration: 5000,
      })
      return
    }
    current.splice(lastIndex, 1)
    setCategories(updated)
  }

  const renderInputs = (items, path = []) => {
    console.log('items', items)
    var _items = items.filter((e) => e.isDeleted != true)
    return _items?.map((item, index) => {
      if (item.isDeleted) {
        return
      }

      const isLast = index === _items.length - 1
      return (
        <div key={item.id} style={{ marginLeft: isEmpty(path) ? 0 : 20, marginBottom: 10 }}>
          <InputGroup style={{ width: '100%', marginBottom: 10 }}>
            <Input
              value={item.masterQuestionName || ''}
              onChange={(val) => handleChange(val, 'masterQuestionName', item.id)}
              placeholder={'คำถามแบบประเมิน'}
              style={{ flex: 1 }}
            />
            <InputGroup.Button
              onClick={() => handleChange(true, 'isDeleted', item.id)}
              //onClick={() => handleRemove(currentPath)}
              className={
                isLast ? 'rs-btn-input-group-delete' : 'rs-btn-input-radius-all-group-delete'
              }
            >
              <Icon
                icon="trash"
                className={isLast ? 'bt-gost-icon-radius-cancel' : 'bt-gost-icon-radius-all-cancel'}
              />
            </InputGroup.Button>
            {true && (
              <InputGroup.Button
                onClick={() => handleAddSameLevel(item.id)}
                className="rs-btn-input-group-save"
              >
                {/* ➕ เพิ่ม */}
                <Icon icon="plus" style={{ marginRight: 10 }} />
                เพิ่ม
              </InputGroup.Button>
            )}
          </InputGroup>
        </div>
      )
    })
  }

  const handleSubmit = () => {
    console.log('categories', categories)

    // สร้าง object ตาม format ที่ต้องการ

    // {
    //   "id": "string",
    //   "masterQuestionName": "string",
    //   "sequence": 0,
    //   "isDeleted": true
    // }

    // {
    //     "id": "688dbd40-e455-4874-989c-45847b13a979",
    //     "masterQuestionName": "svsdv"
    // }

    var data = clone(categories)

    data = data?.filter((e) => !(e.id.includes('new-') && e.isDeleted === true))
    data = data?.map((item, index) => {
      if (item.id.includes('new-')) {
        item.id = null
      }
      item.sequence = index + 1
      return item
    })

    const request = data || []
    console.log('📦 ข้อมูลฟอร์ม:', request)

    handleSave(request)
  }

  const handleAddBlock = () => {
    setCategories([{ id: `${uuidv4()}`, value: null, parentId: null, children: [] }])
  }

  return (
    <>
      <Panel shaded collapsible={false} defaultExpanded header={' '} bordered>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={24} md={24} sm={24} xs={24}>
            {/* <b>หมวดหมู่แบบประเมิน</b> */}
            {renderInputs(categories)}
          </Col>
        </Row>

        {categories.filter((i) => i.isDeleted != true).length == 0 && (
          <Button onClick={() => handleAddBlock()} appearance="primary" icon={<Icon icon="plus" />}>
            เพิ่มคำถาม
          </Button>
        )}

        <Row>
          <Col lg={16} md={16} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton onClick={handleSubmit} style={{ marginRight: 10, marginBottom: 10 }}>
              บันทึก
            </SaveButton>
            {/* <CancelButton onClick={handleCancel}>ยกเลิก</CancelButton> */}
          </Col>
        </Row>
      </Panel>
      <br />
      <br />
      <br />
    </>
  )
}
